var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('div',[_vm._t("default")],2),_c('span',{ref:"text",staticClass:"tooltiptext"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }